import { ChangeEvent } from "react";

type ICheckbox = {
  label: string;
  name: string;
  id: string;
  checked?: boolean;
  isRequired?: string;
  readonly?: boolean;
  styles?: string;
  onChange?(e: ChangeEvent<HTMLInputElement>): void;
};

export default function CheckBox({
  label,
  id,
  name,
  checked,
  isRequired,
  readonly,
  styles,
  onChange,
}: ICheckbox) {
  return (
    <div>
      <input
        type="checkbox"
        id={id}
        name={name}
        is-required={isRequired}
        checked={checked}
        readOnly={readonly}
        onChange={onChange}
      />
      <label className={styles} htmlFor={id}>
        {label}
      </label>
    </div>
  );
}
